import styled from 'styled-components';
import Container from '../Container';
import Icon from '../Icon';
import Typography from '../Typography';
export const LozengeStyled = styled(Container)(({ theme, color = 'blue', variant = 'light', onClick, }) => {
    var _a, _b, _c;
    return ({
        backgroundColor: (_a = theme === null || theme === void 0 ? void 0 : theme.colors[color]) === null || _a === void 0 ? void 0 : _a[variant],
        color: variant == 'dark' ? (_b = theme === null || theme === void 0 ? void 0 : theme.colors[color]) === null || _b === void 0 ? void 0 : _b.contrastText : theme === null || theme === void 0 ? void 0 : theme.palette.text.primary,
        padding: '3px 8px',
        borderRadius: '5px',
        lineHeight: '1',
        alignItems: 'center',
        display: 'inline-flex',
        gap: '8px',
        userSelect: 'none',
        cursor: 'default',
        [theme === null || theme === void 0 ? void 0 : theme.breakpoints.only('mobile')]: {
            padding: '4px 5px',
            gap: '5px',
        },
        ...onClick && {
            cursor: 'pointer',
            boxShadow: (_c = theme === null || theme === void 0 ? void 0 : theme.shadows) === null || _c === void 0 ? void 0 : _c.s,
        },
    });
});
export const LozengeText = styled(Typography).attrs({
    variant: 'overline',
})(({ theme, }) => ({
    color: 'inherit',
    height: '1em',
    [theme === null || theme === void 0 ? void 0 : theme.breakpoints.only('mobile')]: {
        fontSize: '10px',
        lineHeight: '12px',
    },
}));
export const LozengeIcon = styled(Icon)(({ theme, }) => ({
    svg: {
        width: '12px',
        height: 'unset',
    },
}));
//# sourceMappingURL=Lozenge.styles.js.map